import { apiSlice } from '../api/api-slice';
import { DeleteStaffRequest } from 'types/add-staff-user/delete-staff';

const deleteStaffApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        deleteStaff: builder.query<void, DeleteStaffRequest>({
            query: (deleteStaffRequest: DeleteStaffRequest) => ({
                url: '/admin/delete-staff-user/' + deleteStaffRequest.id,
                method: 'DELETE',
            }),
        }),
    }),
});
export const { useLazyDeleteStaffQuery } = deleteStaffApi;
